import React from "react";
import CKEditor from "react-ckeditor-component";

import Tag from "../../components/Tag";
import FormButtonGroup from "./FormButtonGroup";

const ExhibitForm = ({
  onSubmit,
  onChange,
  clearForm,
  onCKEditorChange,
  title,
  description,
  tags,
  dataLoaded
}) => {
  return (
    <form onSubmit={onSubmit}>
      <FormButtonGroup clearForm={clearForm} />

      <div className="form-group">
        <label htmlFor="input">Title</label>
        <input
          type="text"
          name="title"
          className="form-control"
          value={title}
          onChange={onChange}
        />
      </div>
      {dataLoaded && (
        <div className="form-group">
          <label htmlFor="description">Description</label>
          <CKEditor
            content={description}
            events={{
              change: onCKEditorChange
            }}
          />
        </div>
      )}
      <div className="row">
        {tags.map(t => {
          return (
            <div className="col-md-3" key={t.tag_id}>
              <div className="form-check">
                <label className="form-check-label">
                  <input
                    type="checkbox"
                    name="tag"
                    className="form-check-input"
                    value={t.tag_id}
                    checked={t.checked}
                    onClick={onChange}
                  />
                  <Tag text={t.tag_name} />
                </label>
              </div>
            </div>
          );
        })}
      </div>

      <FormButtonGroup clearForm={clearForm} />
    </form>
  );
};

export default ExhibitForm;



// WEBPACK FOOTER //
// ./src/pages/ManageExhibit/Form.jsx